import React from "react";
import 'bootstrap/dist/css/bootstrap.min.css'
import './css/App.css';
import PortfolioContainer from './components/PortfolioContainer'

// App is NOT presently responsive.
const App = () => < PortfolioContainer/>;

export default App;